var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBreakdownInsightsDm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 141,
    viewBox: "0 0 440 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 20.4189)",
    fill: "#DF8981"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 50.4189)",
    fill: "#DF8981"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 50.4189)",
    fill: "#CAD2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 30.4189,
    width: 201,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 80.4189)",
    fill: "#DF8981"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 80.4189)",
    fill: "#CAD2FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 60.4189,
    width: 90,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 110.419)",
    fill: "#DF8981"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 305,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 110.419)",
    fill: "#CAD2FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 90.4189,
    width: 164,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 140.419)",
    fill: "#DF8981"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 401,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 140.419)",
    fill: "#CAD2FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 120.419,
    width: 213,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBreakdownInsightsDm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/breakdown-insights-dm.f561eb3c29cdc4370123a96f5e620724.svg";